<div class="mb-3">
  <ng-container>
    <ps-ui-table [data]="multiCountrySurveyData">
      <ng-container
        psUiTableExpandableRow
        [behavior]="'each'"
        [manualClose]="true"
      >
        <ng-container
          psUiTableCheckboxColumn
          selectBy="survey_id"
          [show]="false"
          [showSelectAll]="false"
          [selectedKeys]="[surveyDetails?.ps_survey_id]"
        ></ng-container>

        <ng-container psUiTableColumn width="fit">
          <ng-template psUiTableColumnCustomHeader>
            <div class="header">Locale</div>
          </ng-template>
          <ng-template
            psUiTableCellTemplate
            (tap)="onSurveySelection($event)"
            let-survey
          >
            <div class="content-container justify-content-start">
              {{ survey.country_name }}
            </div>
          </ng-template>
        </ng-container>

        <ng-container psUiTableColumn width="fit">
          <ng-template psUiTableColumnCustomHeader>
            <div class="header"></div>
          </ng-template>
          <ng-template
            psUiTableCellTemplate
            (tap)="onSurveySelection($event)"
            let-survey
          >
            <div class="content-container">
              <span class="p-1 fw-bold language-icon">{{
                survey.language_code | uppercase
              }}</span>
            </div>
          </ng-template>
        </ng-container>

        <ng-container psUiTableColumn width="fit">
          <ng-template psUiTableColumnCustomHeader>
            <div class="header">CPI</div>
          </ng-template>
          <ng-template psUiTableCellTemplate let-survey let-row="index">
            <div class="content-container">
              <div *ngIf="!survey.loading" class="d-flex align-items-center">
                <ng-container *ngIf="isCpiEditable">
                  <div
                    *ngIf="survey.state.cpi === 'view'"
                    class="d-flex align-items-center"
                    title="click to edit"
                  >
                    {{ survey.currency_symbol
                    }}{{ survey.cpi | number : '1.2-2' }}
                    <span
                      class="fa fa-pencil mx-1"
                      (click)="survey.state.cpi = 'edit'"
                    ></span>
                  </div>

                  <ng-container *ngIf="survey.state.cpi !== 'view'">
                    {{ survey.currency_symbol }}
                    <input
                      #inputCpi
                      type="number"
                      class="cpi-input-box p-1 mx-1"
                      [value]="survey.cpi | number : '1.2-2'"
                      [ngModel]="survey.cpi"
                      (ngModelChange)="onCpiChange(survey, row, $event)"
                      psUiInputRestriction="[0-9.]"
                      psUiInputDecimalRestriction
                    />
                    <div
                      class="d-flex align-items-center justify-content-center action-container"
                    >
                      <div
                        class="d-flex align-items-center fa fa-check glyphicon glyphicon-ok p-1"
                        (click)="onCpiUpdate(survey, inputCpi.value)"
                      ></div>
                      <div
                        class="d-flex align-items-center fa fa-remove glyphicon glyphicon-remove p-1 text-danger"
                        (click)="
                          survey.state.cpi = 'view'; hideCpiConfirmationRow(row)
                        "
                      ></div>
                    </div>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="!isCpiEditable">
                  {{ survey.currency_symbol
                  }}{{ survey.cpi | number : '1.2-2' }}
                </ng-container>
              </div>
              <ps-ui-ellipsis-loader
                [show]="survey.loading"
              ></ps-ui-ellipsis-loader>
            </div>
          </ng-template>
        </ng-container>

        <ng-container psUiTableColumn width="fit">
          <ng-template psUiTableColumnCustomHeader>
            <div class="header">Feasibility</div>
          </ng-template>
          <ng-template
            psUiTableCellTemplate
            (tap)="onSurveySelection($event)"
            let-survey
          >
            <div class="content-container">
              <div
                class="d-flex justify-content-center align-items-center flex-column"
              >
                <span *ngIf="!survey.loading">{{
                  survey.feasibility | number
                }}</span>
                <ps-ui-ellipsis-loader
                  [show]="survey.loading"
                ></ps-ui-ellipsis-loader>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="!isSurveyNotDraft" psUiTableColumn width="fit">
          <ng-template psUiTableColumnCustomHeader>
            <div class="header">Delete</div>
          </ng-template>
          <ng-template psUiTableCellTemplate let-survey>
            <div class="content-container">
              <div
                class="d-flex justify-content-center align-items-center flex-column"
              >
                <i class="fa fa-trash" (click)="onSurveyDelete(survey)"></i>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <ng-template psUiTableExpandableContent let-survey let-index="index">
          <div class="d-flex align-items-center confirm-box">
            <div class="p-1">
              Please confirm the Override CPI value you have entered to the
              accurate
            </div>
            <div class="multicountry-confirm-button">
              <button
                type="button"
                psUiButton
                size="small"
                (click)="onCpiConfirmation(survey, index)"
              >
                Confirm
              </button>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </ps-ui-table>
  </ng-container>

  <ng-container *ngIf="multiCountrySurveyData.length && !isSurveyNotDraft">
    <div class="add-country-container d-flex justify-content-around py-2">
      <div>
        <ps-ui-select-dropdown
          class="btn country-dropdown"
          [dropdownItems]="filteredCountries"
          [field]="'name'"
          [loading]="false"
          [clearSearch]="false"
          [label]="selectedCountry.name || 'Select Country'"
          labelNone="Select Country"
          labelAlignment="start"
          (selectedItem)="selectCountry($event)"
        >
        </ps-ui-select-dropdown>
      </div>

      <div>
        <ps-ui-select-dropdown
          class="btn country-dropdown"
          [dropdownItems]="languages"
          [field]="'name'"
          [loading]="false"
          [clearSearch]="false"
          [disabled]="!languages.length"
          [firstSelected]="true"
          labelNone="Select Language"
          labelAlignment="start"
          (selectedItem)="setLanguage($event)"
        >
        </ps-ui-select-dropdown>
      </div>

      <div
        class="d-flex align-items-center fa fa-check glyphicon glyphicon-ok p-1 mx-1 text-white bg-primary"
        (click)="onNewSurveyCreation()"
      ></div>
    </div>

    <ng-container>
      <div *ngIf="isLaunchSurveyPage" class="p-5">
        <div class="d-flex justify-content-center my-2">
          <button
            psUiButton
            class="save-btn"
            (click)="onLaunchAllSurveys()"
            psUiGtagEvent
            trackOn="click"
            action="launch_survey"
            category="Survey_Launch"
            [params]="{ event_label: 'Multi Country Surveys Launched' }"
          >
            Launch all Surveys
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
